import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const Score = styled.div`
  color: var(--v3-text-color);
  left: 0;
  top: 16px;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  letter-spacing: 0.64px;
  transform: translateX(-50%);
  ${!isMobile() &&
  `
      top: 5px;
      line-height: 24px;
      font-size: 24px;
  `}
`;

const PADDING_INCREMENT = 30;

export const TeamInfo = styled.div<{
  paddingLeft?: number;
  paddingRight?: number;
}>`
  display: flex;
  flex-direction: ${isMobile() ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${isMobile() ? '12px' : '8px 16px'};
  ${props =>
    !isMobile() &&
    `
    ${
      props.paddingLeft !== undefined
        ? `padding-left: ${props.paddingLeft + PADDING_INCREMENT}px;`
        : ''
    }
    ${
      props.paddingRight !== undefined
        ? `padding-right: ${props.paddingRight + PADDING_INCREMENT}px;`
        : ''
    }
    padding-top: 0;
    padding-bottom: 0;
    line-height: 24px;
  `}
`;

export const Logo = styled.div<{ isFirstLogo?: boolean }>`
  height: 32px;
  width: 32px;
  ${props => !isMobile() && props.isFirstLogo && 'order: 2;'};
  border-radius: 50%;
  background: rgba(185, 185, 185, 0.15);
  display: flex;
  padding: 4px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
